import axios from 'axios';
import { LOCKWIZARD_API, ENVIRONMENT } from './core/constants';
import AuthService from './auth.service';

export class LockWizardApi {
    private accessToken: string;
    private localToken = '';
    private localIDP =
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6ImVMTDdhTUh6bHhDY2NMMFRNaUpSaUZ3MUxsM0h3SzIxWkhuT3FRU1JtcVEifQ.eyJqdGkiOiI0MjE3ZTBhNi1jMzE4LTRhMDUtODZhYy02ODU4MGEzNWNiNDMiLCJleHAiOjE2Njg1Mjk3OTksImlhdCI6MTY2ODUyOTE5OSwiaXNzIjoiYWNjb3VudHMudmFjYXNhLmlvIiwic2NvcGVzIjpbInR1cm5rZXktbG9jazpyZWFkIl0sImF1ZCI6ImxvY2std2l6YXJkLmFwaS52YWNhc2EuaW8iLCJzdWIiOiI3ZWRmNTFhZi0yZDQ1LTQ3ZDYtYjI5Yy0yNGU4YTg5NmM0YjUifQ.ab3McqFtQ2eh_3PXclaIySj6Kqkb9YHCtZhGTmK2ttcg-TzTMeWH9pj3cYqdATNU1wJ4vD27MulQNdvWpKwlWWq2JoPy_FAWyEcwzqDIbocaC8UzGMMH0nP82VofsOIS1v7Ya3QlGGHlH1BWQ2mRxMo8U3XdkuHxDbnXcUKFasKRpjU2TMwrfdsy8fpY5jNQvwYMaFPflOE1L1y4TNR6kAUAd2JEEkTpBHvocYnS9q2548c398xvxSHhAe29V3U5V-iaiW-wS_BrMHlXHHQgxD5dGuI4k_dDPLTUZ9Wttbq-XlID9ha54Ta16Koct0WwNgD63us3dGkRybG7rrrh-Q';

    constructor() {
        this.accessToken = '';
    }

    async getToken(): Promise<any> {
        let token = AuthService.idpToken;
        if (!this.accessToken) {
            if (ENVIRONMENT === 'local') {
                if (this.localIDP) {
                    token = this.localIDP;
                } else return this.localToken;
            }

            const url = `${LOCKWIZARD_API}/lockserver/getforui`;
            console.log('t:' + token);
            try {
                const res = await axios.get(url, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });
                return res.data;
            } catch (err) {
                console.log(err);
            }
        }
        return this.accessToken;
    }
    async removeLock(lockId: string): Promise<any> {
        let token = AuthService.idpToken;
        if (ENVIRONMENT === 'local') {
            if (this.localIDP) {
                token = this.localIDP;
            }
        }

        const url = `${LOCKWIZARD_API}/lockserver/removeLock`;

        try {
            const res = await axios.post(
                url,
                { lockId: lockId },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                },
            );
            console.log('remove lock res: ', res);
            return true;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
}
